import React, { useState } from 'react';
import { ChevronDownIcon, GiftIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const bonuses = [{
    title: 'BONO 1 — PACK DE PLANTILLAS EDITABLES',
    preview: 'https://cdn.magicpatterns.com/uploads/jpT9b9r4S6p4r89eGHy2Zu/Screenshot_2026-06-20_at_6.26.43_PM.png',
    items: ['✅ Legajo de empleado', '✅ Formulario de ingreso', '✅ Acta de apercibimiento', '✅ Carta documento de despido', '✅ Notificación de vacaciones', '✅ Entrevista de permanencia', '✅ Entrevista de salida', '✅ Reporte mensual de RRHH', '✅ Planilla de asistencia automática', '✅ Base maestra de empleados']
  }, {
    title: 'BONO 2 — GUÍA DE SITUACIONES DE ALTO RIESGO LEGAL',
    subtitle: '15 Casos Reales de PYMES Argentinas',
    preview: 'https://cdn.magicpatterns.com/uploads/uSVmSDkPi3WWEA1EocNjuD/Screenshot_2026-06-20_at_6.27.10_PM.png',
    items: ['• Trabajo no registrado', '• Despido sin documentación', '• Embarazo', '• Monotributo encubierto', '• Accidentes laborales', '• Mobbing', '• Hostigamiento', '• Abandono de trabajo', '• Licencias mal gestionadas', '• Certificados médicos cuestionados', '• Horas extras reclamadas', '• Falta de sanciones documentadas', '• Conflictos sindicales básicos', '• Desvinculaciones conflictivas', '• Errores de legajo']
  }, {
    title: 'BONO 3 — CALENDARIO ANUAL DE RRHH',
    subtitle: 'Sistema de Organización Anual',
    preview: 'https://cdn.magicpatterns.com/uploads/qBjqER61iuj5xYe74QP5bR/Screenshot_2026-06-20_at_6.27.19_PM.png',
    items: ['✅ SAC', '✅ Vacaciones', '✅ Evaluaciones de desempeño', '✅ Períodos de prueba', '✅ ART', '✅ Capacitaciones', '✅ Entrevistas de seguimiento', '✅ Reportes mensuales', '✅ Alertas automáticas', '✅ Vista anual y mensual editable']
  }, {
    title: 'BONO 4 — CALCULADORA DE INDEMNIZACIÓN Y LIQUIDACIÓN FINAL',
    subtitle: 'Planilla automática lista para usar',
    preview: 'https://cdn.magicpatterns.com/uploads/7dqwdzUc3JVmNuGMVmq7QX/Screenshot_2026-06-24_at_1.25.46_PM.png',
    items: ['✅ Liquidación final completa', '✅ Indemnización por antigüedad (art. 245 LCT)', '✅ Preaviso e integración del mes', '✅ SAC y vacaciones proporcionales', '✅ Cálculo automático paso a paso', '✅ Guía y referencias incluidas']
  }, {
    title: 'BONO 5 — CALCULADORA DE LIQUIDACIONES DE SUELDOS',
    subtitle: 'Planilla automática lista para usar',
    preview: 'https://cdn.magicpatterns.com/uploads/9DVpMYZWghvzZjBwCCFCoy/Screenshot_2026-06-24_at_1.25.05_PM.png',
    items: ['✅ Recibo de sueldo mensual', '✅ Haberes remunerativos y no remunerativos', '✅ Horas extra al 50% y 100%', '✅ Antigüedad y presentismo', '✅ Descuentos y aportes', '✅ Histórico anual y nómina del mes']
  }, {
    title: 'BONO 6 — GUION DE CONVERSACIONES DIFÍCILES',
    subtitle: 'Qué decir, palabra por palabra',
    preview: 'https://cdn.magicpatterns.com/uploads/5BnqvNx6t9oRoLhJjcHHc3/Screenshot_2026-06-24_at_1.26.37_PM.png',
    items: ['✅ Cómo dar una mala noticia', '✅ Qué decir si la persona se enoja', '✅ Cómo poner límites con calma', '✅ Frases listas para usar', '✅ Qué evitar en cada situación', '✅ Guion para entrevistas de salida']
  }, {
    title: 'BONO 7 - NUEVO. MINI AUDITORIA DE AREA',
    subtitle: '1 Excel — 3 hojas',
    preview: 'https://cdn.magicpatterns.com/uploads/8FSGYFYZG56ZvBgRL9V41r/Screenshot_2026-07-09_at_1.38.57_PM.png',
    items: ['35 preguntas en 7 bloques con semáforo automático (🟢🟡🔴) y panel de resultados que genera las 3 prioridades inmediatas ordenadas por riesgo legal. Pensado para usarse antes de arrancar el kit.']
  }, {
    title: 'BONO 8 — GUÍA F931',
    subtitle: 'Guía práctica para controles mensuales desde RRHH',
    preview: 'https://cdn.magicpatterns.com/uploads/ohqTSExvuCSwKJMyd4Z5kx/Screenshot_2026-07-20_at_7.27.18_PM.png',
    items: ['✅ Qué controlar antes de la presentación', '✅ Verificación de altas, bajas y nómina', '✅ Errores frecuentes y cómo resolverlos']
  }, {
    title: 'BONO 9 — GUÍA DE GANANCIAS, CUARTA CATEGORÍA',
    subtitle: 'Referencia clara para acompañar la gestión de RRHH',
    preview: 'https://cdn.magicpatterns.com/uploads/mJEpmpkWRvGjZ9rZVkcUpu/Screenshot_2026-07-20_at_7.27.41_PM.png',
    items: ['✅ Deducciones y conceptos principales', '✅ Ganancia mínima no imponible', '✅ Formulario 572 / SiRADIG']
  }];
  return <section className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-1" data-mp="ud3piuk23d09">
      <div className="text-center mb-10" data-id="element-2" data-mp="ueoiwgumwpwj">
        <div className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-100 to-purple-100 px-6 py-3 rounded-full mb-4" data-id="element-3" data-mp="pmevp8kwm3xy">
          <GiftIcon className="w-5 h-5 text-pink-600" data-id="element-4" data-mp="14a8ef25admkr" />
          <span className="font-bold text-pink-600" data-id="element-5" data-mp="14d4dwuws8jbb">GRATIS solo por hoy</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900" data-id="element-6" data-mp="zeb174pbkwc7">
          9 Bonos Exclusivos
        </h2>
      </div>

      <div className="space-y-3" data-id="element-7" data-mp="19anrdslnos27">
        {bonuses.map((bonus, index) => <div key={index} className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg border-2 border-purple-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-8" data-mp="198jondzhtz3i" data-mpi={index}>
            <div className="relative h-36 w-full overflow-hidden border-b border-purple-200 bg-white" data-id="element-9" data-mp="1e1mth5wbah6x">
              <img src={bonus.preview} alt={`Vista previa de ${bonus.title}`} className="w-full h-full object-cover object-top" data-id="element-10" data-mp="1izeldzwyi3b4" />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-50 via-purple-50/20 to-transparent" data-id="element-11" data-mp="1syx3sbx7xh12" />
            </div>
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-white/50 transition-colors duration-200" data-id="element-12" data-mp="1wz7lumyabxwa">
              <div data-id="element-13" data-mp="2bovkfgf30igb">
                <div className="flex items-center gap-2 mb-1" data-id="element-14" data-mp="2bpewigi1wcmf">
                  <GiftIcon className="w-5 h-5 text-pink-500" data-id="element-15" data-mp="2bqpxy9o0x8ad" />
                  <span className="text-xs font-semibold text-pink-600 uppercase" data-id="element-16" data-mp="2gp9nek1tt27h">
                    Bono Gratis
                  </span>
                </div>
                <span className="font-semibold text-gray-900" data-id="element-17" data-mp="92py00qtgqwj">
                  {bonus.title}
                </span>
                {bonus.subtitle && <p className="text-sm text-gray-600 mt-1" data-id="element-18" data-mp="4zbkbgqcomm9">{bonus.subtitle}</p>}
              </div>
              <motion.div animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.3
          }} data-id="element-19" data-mp="3cxvyol1eoh">
                <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-20" data-mp="nqkt1nsar7cs" />
              </motion.div>
            </button>

            <AnimatePresence data-id="element-21" data-mp="izchal3hv9wg">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} className="overflow-hidden" data-id="element-22" data-mp="e1kozpyxtlrq">
                  <div className="px-6 py-4 bg-white/70 border-t border-purple-200" data-id="element-23" data-mp="62igcs4wdwd7">
                    <div className="grid md:grid-cols-2 gap-2" data-id="element-24" data-mp="a2svovekxz4q">
                      {bonus.items.map((item, itemIndex) => <div key={itemIndex} className="text-gray-700 text-sm" data-id="element-25" data-mp="xu6latlcjgm0" data-mpi={itemIndex}>
                          {item}
                        </div>)}
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}